/**
 * 角色权限处理
 * Copyright (c) 2019 ruoyi
 */

import store from '@/store'

export default {
    mounted(el, binding, vnode) {
        const {value} = binding
        const super_admin = "admin";
        let roles = store.getters && store.getters.roles

        if (value && value instanceof Array && value.length > 0) {
            const roleFlag = value
            roles = JSON.parse(roles);
            const hasRole = roles.some(role => {
                return super_admin === role || roleFlag.indexOf(role) !== -1
            })

            if (!hasRole) {
                el.parentNode && el.parentNode.removeChild(el)
            }
        } else {
            throw new Error(`请设置角色权限标签值"`)
        }
    }
}
